<template>
  <div class="container py-4">
    <div class="row px-sm-0 px-md-3">
      <!-- Manufacturer -->
      <div class="col-sm-12 col-md px-sm-2 px-md-0">
        <div class="container">
          <div class="row">
            <div class="col">{{ trans('Manufacturer') }}</div>
          </div>
          <div class="row">
            <div class="col">
              <v-select
                v-model="manufacturer"
                :reduce="option => option.value"
                :placeholder="trans('Manufacturer')"
                :disabled="!manufacturers || !manufacturers.length"
                :options="manufacturers"></v-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Model -->
      <div class="col-sm-12 col-md px-sm-2 px-md-0">
        <div class="container">
          <div class="row">
            <div class="col">{{ trans('Model') }}</div>
          </div>
          <div class="row">
            <div class="col">
              <v-select
                v-model="model"
                :placeholder="trans('Model')"
                :disabled="!models || !models.length"
                :options="models"
              ></v-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Color -->
      <div class="col-sm-12 col-md px-sm-2 px-md-0">
        <div class="container">
          <div class="row">
            <div class="col">{{ trans('Color') }}</div>
          </div>
          <div class="row">
            <div class="col">
              <v-select
                v-model="color"
                :reduce="option => option.value"
                :placeholder="trans('Color')"
                :disabled="!colors || !colors.length"
                :options="colors"
              ></v-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Body Type -->
      <div class="col-sm-12 col-md px-sm-2 px-md-0">
        <div class="container">
          <div class="row">
            <div class="col">{{ trans('Body Type') }}</div>
          </div>
          <div class="row">
            <div class="col">
              <v-select
                v-model="bodyType"
                :reduce="option => option.value"
                :placeholder="trans('Body Type')"
                :disabled="!bodyTypes || !bodyTypes.length"
                :options="bodyTypes"
              ></v-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Status -->
      <div class="col-sm-12 col-md px-sm-2 px-md-0">
        <div class="container">
          <div class="row">
            <div class="col">{{ trans('Status') }}</div>
          </div>
          <div class="row">
            <div class="col">
              <v-select
                v-model="status"
                :reduce="option => option.value"
                :placeholder="trans('Status')"
                :clearable="false"
                :disabled="!statuses || !statuses.length"
                :selectable="option => !option.disabled"
                :options="statuses"
              ></v-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row pt-4">
      <div class="col">
        <preloader :loading="loading" />

        <section
          class="vehicle-list section section-no-border custom-section-spacement-1 bg-color-light m-0 py-0"
          v-html="searchResults"
        ></section>

        <div v-if="hasMorePages" class="row">
          <div class="col-lg-12 text-center">
            <a
              href="#"
              class="btn btn-outline btn-primary custom-btn-style-2 font-weight-semibold text-color-dark text-uppercase mt-3"
              @click.prevent="getResults"
            >
              {{ trans('View More') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { apiFetchEnum } from '../api';

  export default {
    name: 'VehicleSearch',

    data() {
      return {
        loading: true,

        searchResults: '',
        manufacturers: [],
        vehicles: [],
        reports: [],
        colors: [],
        bodyTypes: [],
        statuses: [],

        hasMorePages: false,
        page: 0,

        manufacturer: null,
        model: null,
        color: null,
        bodyType: null,
        status: null,
      }
    },

    computed: {
      models() {
        const models = [];
        this.getFilteredVehicles(['model']).map(item => {
          const model = item.model;
          if (models.indexOf(model.toLowerCase()) === -1) {
            models.push(model);
          }
        });

        return models.sort();
      },
    },

    mounted() {
      Promise
        .all([
          apiFetchEnum('manufacturer', { existing:  1 }),
          apiFetchEnum('body_type', { existing:  1 }),
          apiFetchEnum('color', { existing:  1 }),
          apiFetchEnum('search_status', { existing: 1 }),
        ])
        .then(values => {
          [
            this.manufacturers,
            this.bodyTypes,
            this.colors,
            this.statuses,
          ] = values;
        })
        .then(() => {
          if (this.statuses[0]) {
            this.status = this.statuses[0].value;
          }
        });
    },

    methods: {
      setLoading(state) {
        this.loading = state !== false;
      },

      fetchVehicles(manufacturerId) {
        this.setLoading();

        return new Promise((resolve, reject) => {
          axios
            .get('/api/vehicle/filter/report', {
              params: {
                manufacturer: manufacturerId,
                registered: 1,
              },
            })
            .then(response => {
              if (response.data && response.data.vehicles) {
                const result = {};

                if (response.data.vehicles) {
                  result['vehicles'] = response.data.vehicles.data;
                }

                if (response.data.reports) {
                  result['reports'] = response.data.reports.data;
                }

                resolve(result);
              }
              reject('No data');
            })
            .catch(e => {
              reject(e);
            })
            .finally(() => {
              this.setLoading(false);
            })
        });
      },

      cleanVehicle() {
        this.vehicles = [];
        this.model = null;
      },

      getFilteredVehicles(excludeFields) {
        let result = this.vehicles || [];
        excludeFields = excludeFields || [];
        const useModelFilter = excludeFields.indexOf('model') === -1;

        if (useModelFilter && this.model) {
          const selectedModel = this.model;
          result = result.filter(item => (item.model === selectedModel))
        }

        return result;
      },

      getResults() {
        this.setLoading();

        return new Promise((resolve, reject) => {
          axios
            .get('/api/vehicle/search', {
              params: {
                manufacturer_id: this.manufacturer,
                body_type_id: this.bodyType,
                model: this.model,
                color_id: this.color,
                status: this.status,
                page: this.page + 1,
              },
            })
            .then(response => {
              if (response.data) {
                this.searchResults += response.data['data'];
                this.hasMorePages = response.data['has_more_pages'];
                this.page = response.data['page'];
              }
            })
            .catch(e => {
              reject(e);
            })
            .finally(() => {
              this.setLoading(false);
            })
        });
      },

      clearSearch() {
        this.searchResults = '';
        this.page = 0;
      }
    },

    watch: {
      manufacturer(item) {
        this.cleanVehicle();

        if (item) {
          this.fetchVehicles(item).then(result => {
            this.vehicles = result.vehicles || null;
          });
        }

        this.clearSearch();
        this.getResults();
      },

      model() {
        this.clearSearch();
        this.getResults();
      },

      color() {
        this.clearSearch();
        this.getResults();
      },

      bodyType() {
        this.clearSearch();
        this.getResults();
      },

      status() {
        this.clearSearch();
        this.getResults();
      }
    },
  }
</script>
